import { render, staticRenderFns } from "./DetailTermsAndConditions.vue?vue&type=template&id=6a12a398&scoped=true"
import script from "./DetailTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./DetailTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./DetailTermsAndConditions.vue?vue&type=style&index=0&id=6a12a398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12a398",
  null
  
)

export default component.exports